export const types = {
    POKEMON_LIST_LOADING: 'POKEMON_LIST_LOADING',
    POKEMON_LIST_SUCCESS: 'POKEMON_LIST_SUCCESS',
    POKEMON_LIST_FAIL: 'POKEMON_LIST_FAIL',
    FILTER_BY_VALUE: 'FILTER_BY_VALUE',
    
    POKEMON_DETAILS_LOADING: 'POKEMON_DETAILS_LOADING',
    POKEMON_DETAILS_SUCCESS: 'POKEMON_DETAILS_SUCCESS',
    POKEMON_DETAILS_FAIL: 'POKEMON_DETAILS_FAIL',    

    UI_SHOW_BTN_BACK: 'UI_ACTIVATE_BTN_BACK',
    UI_HIDE_BTN_BACK: 'UI_HIDE_BTN_BACK',
    
}